import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Tabs, Button } from 'antd';
import _ from 'lodash'; // Import the entire lodash library
import 'antd/dist/antd.css';
import '@ant-design/compatible/assets/index.css';
import axios from 'axios';
import FileConstants from '../../../../FileConstants';
import ENVIRONMENT from '../../../../environments';
import RoomsListVirtualized from './RoomsListVirtualized';
import Filters from './Filters';
import DottedLoader from '../../DottedLoader';
import { CheckCircleFilled, LoadingOutlined } from '@ant-design/icons';
const { TabPane } = Tabs;

const SelectScene = (props) => {
  const COMPANY_ID = FileConstants.COMPANY_ID;
  const SHARED_ENTITIES = FileConstants.SHARED_ENTITIES;
  const CUSTOMER_USERNAME = FileConstants.CUSTOMER_USERNAME;
  const IS_MS_PROVIDER = FileConstants.isMSProvider;
  const MANAGED_COMPANY_ID = FileConstants.MANAGED_COMPANY_ID;
  const MANAGED_CUSTOMER_USERNAME = FileConstants.MANAGED_CUSTOMER_USERNAME;
  const [ownedSceneData, setOwnedSceneData] = useState([]);
  const [sharedSceneData, setSharedSceneData] = useState([]);
  const [mspUserData, setMspUserData] = useState([]);
  const [storeSceneData, setStoreSceneData] = useState([]);
  const [tabActiveKey, setTabActiveKey] = useState('owned');
  const [categories, setCategories] = useState([]);
  const [isMSProvider, setIsMSProvider] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [dataLoading, setDataLoading] = useState(false);
  const [mspFilteredData, setMspFilteredData] = useState([]);
  const [ownedFilteredData, setOwnedFilteredData] = useState([]);
  const [sharedFilteredData, setSharedFilteredData] = useState([]);
  const [storeFilteredData, setStoreFilteredData] = useState([]);
  const [productCollections, setProductCollections] = useState(null);
  const [initialLoadShared, setInitialLoadShared] = useState(true);
  const [initialLoadOwned, setInitialLoadOwned] = useState(true);
  const [sharedSceneLoader, setSharedSceneLoader] = useState(true);
  const [ownedSceneLoader, setOwnedSceneLoader] = useState(true);  
  const {
    selectedRoom,
    setSelectedRoom,
    setStep,
    handleSubmit,
    setLoading,
    setIsStore,
    loading,
    multiple_select,
    selectedScenes,
    setSelectedScenes,
    creationType,
  } = props;
  const tabs = [
    {
      type: 'msp',
      title: `${localStorage.getItem('managed_customer_username')}'s scenes (${
        mspFilteredData.length
      })`,
      data: mspUserData,
      setData: setMspFilteredData
    },
    {
      type: 'owned',
      title: `Your Scenes ${ownedSceneLoader ? '' : `(${ownedFilteredData.length})`}`,
      data: ownedSceneData,
      setData: setOwnedFilteredData
    },
    {
      type: 'other',
      title: `Other Scenes ${sharedSceneLoader ? '' : `(${sharedFilteredData.length})`}`,
      data: sharedSceneData,
      setData:  setSharedFilteredData
    },
  ];
  if(creationType != 'add-product-to-existing-scene'){
    tabs.push(
        {
            type: 'store',
            title: `Store Templates (${storeFilteredData.length})`,
            data: storeSceneData,
            setData: setStoreFilteredData
        },
    )
  }

  useEffect(() => {
    if(creationType != '')
    {
        if (props.empty_scene == true) {
            if(creationType == 'add-product-to-existing-scene'){
                setTabActiveKey("owned");
                setIsStore(false);
            }
            else{
                setTabActiveKey("store");
                setIsStore(true);
            }
        } else {
        setTabActiveKey("owned");
        setIsStore(false);
        }
    }
  }, [props.empty_scene, creationType]);

  const getScenePayload = (initial, type, sequence_id) => {
    const payload = {
      order_by: 'id desc',
      required_fields: [
        'id',
        'name',
        'scene_status',
        'thumbnail',
        'designed_for',
        'company_id',
        'scene_template_id',
        'render_generation',
        'collection_id',
        'customer_username',
        'img_render_count',
        'three_sixty_count',
        'threed_tour_count',
        'platform',
        'tags',
        'space_areas'
      ],
    };

    if (FileConstants.isMSProvider) {
      payload['order_by'] = 'id desc';
    } else {
      if (sequence_id != -1) {
        payload['required_fields'].push(
            'folder_id',
            'folder_name',
            'parent_folder_id',
            'library_order',
            'entity_order',
        );
        payload['order_by'] = 'library_order asc,entity_order asc';
      } else {
        payload['order_by'] = 'id desc';
      }
    }

    let filter_string = '';
    const scene_status = 'scene_status__in=[3]';
    let company_id = '';
    let shared_username = '';
    const is_hidden = 'is_hidden__not=true';
    const shared_hidden = 'shared_hidden__not=true';
    const customer_username = `customer_username__exact='${CUSTOMER_USERNAME}'`;
    const customer_username_notexact =
      'customer_username__notexact=\'' + CUSTOMER_USERNAME + '\'';
    const sequence_id_value = 'sequence_id__exact=' + sequence_id;
    const scene_template_null_true = '(scene_template_id__isnull=true)';
    const scene_template_null_false = 'scene_template_id__isnull=false';
    const company_id_notexact = `company_id__notexact=${COMPANY_ID}||company_id__isnull=true`;
    const designed_for = '&&(designed_for__isnull=true)';
    if (type == 'shared') {
      shared_username = 'shared_username__exact=\'' + CUSTOMER_USERNAME + '\'';
      filter_string = `(${shared_username}&&${shared_hidden}&&${customer_username_notexact})||(${customer_username}&&${scene_template_null_false}&&${is_hidden})`;

      if (
        SHARED_ENTITIES != undefined &&
        COMPANY_ID != undefined &&
        SHARED_ENTITIES.split('_').includes('scene')
      ) {
        const company_access = `||(company_access__exact='${COMPANY_ID}')`;
        company_id = `company_id__exact=${COMPANY_ID}`;
        filter_string =
          filter_string +
          `||(${company_id}&&${scene_template_null_false}&&${is_hidden})` +
          company_access;
      }

      filter_string = '(' + filter_string + ')';
    } else if (
      SHARED_ENTITIES != undefined &&
      COMPANY_ID != undefined &&
      SHARED_ENTITIES.split('_').includes('scene')
    ) {
      company_id = `company_id__exact=${COMPANY_ID}`;
      filter_string = `(${company_id}||${customer_username})&&(${scene_status}&&${is_hidden})&&${scene_template_null_true}`;
    } else {
      filter_string = `(${customer_username}&&${scene_status}&&${is_hidden})&&${scene_template_null_true}`;
    }

    if (sequence_id != -1) {
      filter_string =
        filter_string +
        '&&(' +
        sequence_id_value +
        '||sequence_id__isnull=true)';
    }

    if(productCollections && productCollections.length != 0)
    {
        filter_string = filter_string + '&&(collection_ids__notin=' + JSON.stringify(productCollections) + ')'
    }
    payload['filter_string'] = filter_string;
    if (initial) {
      payload['pagination_filters'] = {
        limit: 100,
        offset: 0,
      };
    }

    if (IS_MS_PROVIDER && type == 'owned') {
      filter_string = filter_string + designed_for;
    }

    payload['filter_string'] = filter_string;

    return payload;
  };

  const getMSPScenePayload = () => {
    const payload = {
      order_by: 'id desc',
      required_fields: [
        'id',
        'name',
        'scene_status',
        'thumbnail',
        'designed_for',
        'company_id',
        'scene_template_id',
        'render_generation',
        'collection_id',
        'customer_username',
        'img_render_count',
        'three_sixty_count',
        'threed_tour_count',
        'platform',
        'tags',
        'space_areas'
      ],
    };
    let filterString = '';

    const sceneStatus = 'scene_status__in=[3]';
    const isHidden = 'is_hidden__not=true';
    const customerUsername = `customer_username__exact='${CUSTOMER_USERNAME}'`;
    const designedFor = `(designed_for__exact='${MANAGED_CUSTOMER_USERNAME}')`;

    filterString = `(${customerUsername}&&${sceneStatus}&&${isHidden})&&${designedFor}`;
    payload['filter_string'] = filterString;

    return payload;
  };

  const getProductCollections = async (SelectedProductID) => {
    const payload = {
        "required_fields":["id"],
        "order_by":"id desc"
    }
    let filterString = `((customer_username__exact='${CUSTOMER_USERNAME}'&&is_hidden__not=true)&&(template_collection_id__is=null)||(has_access_to__like='%\"${CUSTOMER_USERNAME}\"%'))&&(product_id__exact=${SelectedProductID})`
    payload['filter_string'] = filterString;

    await axios.post(ENVIRONMENT.LIST_COLLECTION, payload).then((res) => {
        let data = res.data
        let collection_list = data.map(ele => ele.id);
        setProductCollections(collection_list)
    });
}

    useEffect(() => {
        if(productCollections)
        {
            fetchSceneData('owned', -1, true);
            fetchSceneData('shared', -1, true);
        }
    }, [productCollections])

  const getRoomsDataWithKeywords = (rooms) => {
    const result = rooms.map((obj) => {
      const keywords = [];

      if (obj.name) {
        for (const keyword of obj.name
            .replace(/[^a-zA-Z0-9 ]/g, ' ')
            .split(' ')) {
          if (!keywords.includes(keyword)) {
            if (keyword.length > 1) {
              keywords.push(keyword.toLowerCase());
            }
          }
        }
      }

      if (obj.room_name) {
        for (const keyword of obj.room_name
            .replace(/[^a-zA-Z0-9 ]/g, ' ')
            .split(' ')) {
          if (!keywords.includes(keyword)) {
            if (keyword.length > 1) {
              keywords.push(keyword.toLowerCase());
            }
          }
        }
      }

      return { ...obj, keywords: keywords };
    });
    return result;
  };

  const fetchMSPCustomerData = async () => {
    const payload = getMSPScenePayload();
    await axios.post(ENVIRONMENT.GET_SCENE_BATCH, payload).then((res) => {
      if (res.data) {
        const data = getRoomsDataWithKeywords(res.data);
        setMspUserData(data);
        setIsMSProvider(true);
      }
    });
  };

  const fetchSceneData = async (type, sequence_id, initial = false) => {
    // setLoader(true);
    if (!initial) {
        setDataLoading(true);
      } else {
        if (type == 'shared') {
          setInitialLoadShared(true);
        } else {
          setInitialLoadOwned(true);
        }
    }
    const payload = getScenePayload(initial, type, sequence_id);
    await axios.post(ENVIRONMENT.GET_SCENE_BATCH, payload).then((res) => {
      if (res.data) {
        const data = getRoomsDataWithKeywords(res.data);
        if (type == 'shared') {
          setSharedSceneData(data);
        } else {
          setOwnedSceneData(data);
        }
        // setLoader(false);

        if (initial) {
            if (type == 'shared') {
              setInitialLoadShared(false);
            } else {
              setInitialLoadOwned(false);
            }
          } else {
            if (type == 'shared') {
              setSharedSceneLoader(false);
            } else {
              setOwnedSceneLoader(false);
            }
          }
      }
    });
  };

  const fetchSpaceCategories = () => {
    const payload = {
      request_type: 'room_model',
    };
    axios.post(ENVIRONMENT.GET_CATEGORY_AND_PRICE, payload).then((res) => {
      let categories = [];
      if (res.data) {
        res.data.map((request) => {
          if (!categories.includes(request.category)) {
            categories.push(request.category);
          }
        });
        categories = categories.filter((item) => item !== '');
        setCategories(categories);
      }
    });
  };

  const handleTabChange = (key) => {
    setTabActiveKey(key);
    if (key == 'store') {
      setIsStore(true);
    } else setIsStore(false);
  };

  const fetchStoreScenesList = async (initial = false) => {
    const payload = {
      action: 'get_batch',
      status: '3',
    };
    await axios
        .post(ENVIRONMENT.TEMPLATE_ACTIONS, payload)
        .then((res) => {
          const data = getRoomsDataWithKeywords(res.data);
          setStoreSceneData(data);
        })
        .catch((error) => {});
  };

  useEffect(() => {
    const fetchData = async () => {
    let prod_id = new URLSearchParams(window.location.search).get("product_id")
      fetchSpaceCategories();
      if(prod_id){
        await getProductCollections(prod_id)
      }
      else{
        await fetchSceneData('owned', -1, true);
        await fetchSceneData('shared', -1, true);
      }
      await fetchStoreScenesList();
      if (
        FileConstants.isMSProvider &&
        (localStorage.getItem('managed_customer_username') != null ||
          MANAGED_COMPANY_ID != null)
      ) {
        await fetchMSPCustomerData();
      }
      setDataLoading(false);
    };

    fetchData();
  }, []);

  useEffect(() => {
    setMspFilteredData(mspUserData);
    setOwnedFilteredData(ownedSceneData);
    setSharedFilteredData(sharedSceneData);
    setStoreFilteredData(storeSceneData);
  }, [mspUserData, ownedSceneData, sharedSceneData, storeSceneData]);

  const continueSteps = () => {
    if (props.empty_scene == true) {
      setStep(3);
    } else {
      handleSubmit("");
    }
   
  }

  useEffect(() => {
    if (!initialLoadOwned && ownedSceneLoader) {
        fetchSceneData('owned', -1);
    }
  }, [initialLoadOwned]);

  useEffect(() => {
    if (!initialLoadShared && sharedSceneLoader) {
        fetchSceneData('shared', -1);
    }
  }, [initialLoadShared]);

  const goBack = () => {
    if(props.match.path.includes("add-product-to-existing-scene")){
        window.location.href = '/list-products'
    }else{
        window.location.href = '/my_scenes'
    }
  }

  return (
    <div className="spaces-list">
      <Filters
        handleValueChange={setSelectedCategories}
        selectedValue={selectedCategories}
        filters={categories}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        title={props.empty_scene == true ? "Select a template" : "Select a scene"}
        searchPlaceholder="Search All Scenes"
      />
      <Tabs
        onChange={(key) => handleTabChange(key)}
        className={`product-tab library ${props.empty_scene == true ? `empty-scene-template` : ``}`}
        tabBarGutter={16}
        size="large"
        activeKey={tabActiveKey}
      >
        {(creationType == 'template-scene' && dataLoading) || (initialLoadOwned || initialLoadShared) ? (
          <DottedLoader />
        ) : (
          tabs?.map((tab, index) => {
            return (index === 0 && !isMSProvider) || (props.empty_scene == true && tab.type != "store") ? null : (
              <TabPane tab={props.empty_scene == true ? '' : tab.title } key={tab.type} style={{ padding: 0 }}>
                <RoomsListVirtualized
                  type="scene"
                  roomsData={tab.data}
                  selectedRoom={selectedRoom}
                  setSelectedRoom={setSelectedRoom}
                  searchValue={searchValue}
                  selectedCategories={selectedCategories}
                  setSelectedCategories={setSelectedCategories}
                  setData={tab.setData}
                  multiple_select={multiple_select}
                  selectedScenes={selectedScenes}
                  setSelectedScenes={setSelectedScenes}
                  creationType={creationType}
                />
              </TabPane>
            );
          })
        )}
      </Tabs>
      
      <div className={`bottom-menu ${((!initialLoadOwned && ownedSceneLoader && tabActiveKey == "owned") || (sharedSceneLoader && tabActiveKey == "other")) ?  'justify-space-between-important' : ``}`} >
      {((!initialLoadOwned && ownedSceneLoader && tabActiveKey == "owned") || (sharedSceneLoader && tabActiveKey == "other")) &&
            <div className='manrope f-16 black-55 justify-in-start ml-100'>
                <LoadingOutlined className='manrope f-24 mr-16' />
                Loading remaining {tabActiveKey} spaces
            </div>}
      <div className='mr-20 justify-in-end'>
            {(multiple_select && (selectedRoom || ( selectedScenes && selectedScenes.length > 0))) && <div className='manrope black-d9 f-16 mr-16'><CheckCircleFilled/> {selectedRoom ? "1" : selectedScenes.length} selected</div>}

              <Button
                  onClick={goBack}
                  className='product-btn br-4 f-16 light-blue pd-16'>
                      Cancel
                </Button>
                <Button
                  onClick={continueSteps}
                  disabled={selectedRoom == null && ( selectedScenes && selectedScenes.length == 0)}
                  className = {(selectedRoom == null && ( selectedScenes && selectedScenes.length == 0)) ? 'product-btn br-4 f-16 disabled-grey ml-16 pd-16' : 'product-btn dark-blue f-16 ml-16 br-4 pd-16'}>
                      Continue {loading ? <LoadingOutlined /> : ''}
                </Button>
            </div>
          </div>
    </div>
  );
};

const mapStateToProps = (state) => state;

export default withRouter(connect(mapStateToProps)(SelectScene));
